import { Col, DatePicker, Row, Space } from 'antd';
import moment, { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import Group from '../Group';
import FloatingFormItem from '../FloatingFormItem';

export interface AgendaData {
  date: Moment;
  render: React.ReactNode[];
}

interface Props {
  dataSource: AgendaData[];
  onChange(date: Moment): void;
  date?: Moment;
}

const AgendaList: React.FC<Props> = ({
  dataSource,
  onChange,
  date: filterDate,
}) => {
  const [date, setDate] = useState(filterDate || moment());

  const days = Array.from({ length: date.daysInMonth() })
    .fill(null, 0)
    .map((_, i) => i + 1);

  useEffect(() => {
    onChange(date);
  }, [date]);

  useEffect(() => {
    if (filterDate && !date.isSame(filterDate, 'month')) {
      setDate(filterDate);
    }
  }, [filterDate]);

  function renderDay(day: number, render?: React.ReactNode[]) {
    return (
      <Group gap={16} align="start">
        <div style={{ height: 50 }}>
          <span style={{ fontWeight: 'bold', lineHeight: 0 }}>
            {String(day).padStart(2, '0')}
          </span>
        </div>
        <Space direction="vertical" style={{ width: '100%' }}>
          {render?.map((item, i) => (
            <div key={i} style={{ width: '100%' }}>
              {item}
            </div>
          ))}
        </Space>
      </Group>
    );
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FloatingFormItem label="Mês">
            <DatePicker
              value={date}
              style={{ width: '100%' }}
              picker="month"
              format="MMMM, YYYY"
              onChange={(value) => {
                if (value) {
                  setDate(date);
                }
              }}
              className="input-capitalize"
            />
          </FloatingFormItem>
        </Col>
      </Row>

      <div style={{ marginTop: 24 }}>
        {days.map((day) => {
          const agendaItem = dataSource.find((item) =>
            item.date.isSame(moment(date.clone()).date(day), 'day'),
          );

          return (
            <div
              key={day}
              style={{ borderTop: '1px solid lightgray', padding: '16px 0px' }}
            >
              {renderDay(day, agendaItem?.render)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgendaList;
